export enum UserRole {
    admin = 'admin',
    user = 'user',
}